import { render, staticRenderFns } from "./DocumentPhotoEdit.vue?vue&type=template&id=8100d208&scoped=true&"
import script from "./DocumentPhotoEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentPhotoEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPhotoEdit.vue?vue&type=style&index=0&id=8100d208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8100d208",
  null
  
)

export default component.exports